__turbopack_context__.v({
  "accLogo": "StateHeader-module-scss-module__fBJfJq__accLogo",
  "accreditationsLabel": "StateHeader-module-scss-module__fBJfJq__accreditationsLabel",
  "accreditationsLogos": "StateHeader-module-scss-module__fBJfJq__accreditationsLogos",
  "accreditationsMobile": "StateHeader-module-scss-module__fBJfJq__accreditationsMobile",
  "accreditationsStrip": "StateHeader-module-scss-module__fBJfJq__accreditationsStrip",
  "actions": "StateHeader-module-scss-module__fBJfJq__actions",
  "badge": "StateHeader-module-scss-module__fBJfJq__badge",
  "badgeDivider": "StateHeader-module-scss-module__fBJfJq__badgeDivider",
  "badgeIcon": "StateHeader-module-scss-module__fBJfJq__badgeIcon",
  "badgeRow": "StateHeader-module-scss-module__fBJfJq__badgeRow",
  "brochureArrow": "StateHeader-module-scss-module__fBJfJq__brochureArrow",
  "brochureBtn": "StateHeader-module-scss-module__fBJfJq__brochureBtn",
  "container": "StateHeader-module-scss-module__fBJfJq__container",
  "decorRect": "StateHeader-module-scss-module__fBJfJq__decorRect",
  "duration": "StateHeader-module-scss-module__fBJfJq__duration",
  "durationIcon": "StateHeader-module-scss-module__fBJfJq__durationIcon",
  "durationText": "StateHeader-module-scss-module__fBJfJq__durationText",
  "heading": "StateHeader-module-scss-module__fBJfJq__heading",
  "headingBold": "StateHeader-module-scss-module__fBJfJq__headingBold",
  "headingRegular": "StateHeader-module-scss-module__fBJfJq__headingRegular",
  "homeHeading": "StateHeader-module-scss-module__fBJfJq__homeHeading",
  "left": "StateHeader-module-scss-module__fBJfJq__left",
  "onlineDot": "StateHeader-module-scss-module__fBJfJq__onlineDot",
  "onlinePill": "StateHeader-module-scss-module__fBJfJq__onlinePill",
  "onlineText": "StateHeader-module-scss-module__fBJfJq__onlineText",
  "section": "StateHeader-module-scss-module__fBJfJq__section",
  "subtitle": "StateHeader-module-scss-module__fBJfJq__subtitle",
});
